import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import locomotiveScroll from 'locomotive-scroll'

gsap.registerPlugin(ScrollTrigger)

export default class Scroller {
  constructor (container) {
    this.container = container
    this.scroller = null
  }

  init () {
    this.locomotive = new locomotiveScroll({
      el: document.querySelector(this.container),
      smooth: true,
      tablet: {
        smooth: true
      }
    })
  
    this.locomotive.on('scroll', ScrollTrigger.update)
  
    ScrollTrigger.scrollerProxy(this.container, {
  
      scrollTop(value) {
        return arguments.length ? this.locomotive.scrollTo(value, 0, 0) : this.locomotive.scroll.instance.scroll.y
      },
  
      getBoundingClientRect() {
        return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight}
      },
      
      pinType: document.querySelector(this.container).style.transform ? 'transform' : 'fixed'
    })
  
    ScrollTrigger.addEventListener('refresh', () => this.locomotive.update())
    ScrollTrigger.refresh()
  
    return this.locomotive
  }
}